import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const ConfirmEmail = () => {
  const { token } = useParams();
  const { setUser } = useAuth();
  const [status, setStatus] = useState('confirming'); // confirming, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    confirmEmail();
  }, [token]);

  const confirmEmail = async () => {
    try {
      await authAPI.confirmEmail(token);
      setStatus('success');

      // Refresh user data so emailConfirmed updates in context
      try {
        const res = await authAPI.getMe();
        if (res.data.user) {
          setUser(res.data.user);
          localStorage.setItem('user', JSON.stringify(res.data.user));
        }
      } catch (e) {
        // User may not be logged in — that's fine
      }
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.error || 'Failed to confirm email');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-background">
        <div className="auth-orb auth-orb-1"></div>
        <div className="auth-orb auth-orb-2"></div>
        <div className="auth-orb auth-orb-3"></div>
      </div>

      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.svg" alt="EchoMemoir" style={{ width: "32px", height: "32px" }} />
          <h1>EchoMemoir</h1>
        </div>

        <div className="auth-form">
          {status === 'confirming' && (
            <>
              <h2>Confirming Email...</h2>
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div className="spinner-large"></div>
              </div>
            </>
          )}

          {status === 'success' && (
            <>
              <h2>Email Confirmed! ✅</h2>
              <div className="auth-success">
                <p>Your email has been confirmed. You're all set!</p>
              </div>
              <Link to="/" className="auth-button" style={{ textDecoration: 'none', textAlign: 'center' }}>
                Go to Dashboard
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <h2>Confirmation Failed</h2>
              <div className="auth-error">{error}</div>
              <Link to="/" className="auth-button" style={{ textDecoration: 'none', textAlign: 'center' }}>
                Go to Dashboard
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;